import { render, staticRenderFns } from "./ConsentsModal.vue?vue&type=template&id=3e1c4e8a"
import script from "./ConsentsModal.vue?vue&type=script&lang=js"
export * from "./ConsentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports